const ITEMS = ["M/S KRISHNA GENERATOR SERVICE", "RENTAL & HIRING", "24/7 POWER", "MAINTENANCE & AMC", "15–500 KVA FLEET"];

export const Marquee = () => (
  <div className="marquee" aria-label="Service promise">
    <div className="marquee-track">
      {[0, 1].map((n) => (
        <div className="marquee-set" key={n} aria-hidden={n === 1}>
          {ITEMS.map((t) => <span className="marquee-item" key={`${n}-${t}`}>{t} <i>•</i></span>)}
        </div>
      ))}
    </div>
  </div>
);
